import { clientFetch } from '@/sanity/lib/client'
import { urlForImage } from '@/sanity/lib/image'
import { getFileAsset } from '@sanity/asset-utils'
import { useEffect, useRef } from 'react'

const Video = ({ imagePlaceholder, video, aspectRatio }) => {
  const base = 'absolute top-0 left-1/2 -translate-x-1/2 h-full'

  const posterSrc = urlForImage(imagePlaceholder).url()

  const videoSrc = getFileAsset(video, clientFetch.config()).url

  const videoRef = useRef(null)

  useEffect(() => {
    videoRef?.current?.play()
  }, [videoSrc])

  return (
    <div
      className={base}
      style={{
        aspectRatio: aspectRatio,
      }}
    >
      <video
        ref={videoRef}
        playsInline
        muted
        loop
        defaultmuted="true"
        poster={posterSrc}
        className="relative w-full h-full object-cover"
      >
        <source src={videoSrc} type="video/mp4" />
      </video>
    </div>
  )
}

export default Video
